import React from "react";
import PropTypes from "prop-types";
import "./GridToggle.scss";

const GridToggleButton = (props) => {
    return (
        <label className="switch">
            <input
                type="checkbox"
                id={props.id || "toggle-button"}
                checked={props.isChecked}
                onChange={props.onChange}
                disabled={props.disabled}
                aria-label="Toggle Button"
            />
            <span className="slider round"></span>
        </label>
    );
}

GridToggleButton.propTypes = {
    isChecked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string,
    disabled: PropTypes.bool,
};

export default GridToggleButton;
